import { useParams } from "@tanstack/react-router";
import { QuickOrderPage } from "./QuickOrderPage";

export function EditDraftOrderPage() {
  const { id } = useParams({ from: "/app/orders/$id/edit" });
  return <QuickOrderPage orderId={id} />;
}
